import * as React from 'react';
import { CircularProgress } from '@material-ui/core';

const CircularProgressBar = () => {
    const [progress, setProgress] = React.useState(0);

    React.useEffect(() => {
        const timer = setInterval(() => {
            setProgress(prevProgress => (prevProgress >= 100 ? 0 : prevProgress + 1.29));
        }, 250);

        return () => {
            clearInterval(timer);
        };
    }, []);

    return <CircularProgress size={20} variant="determinate" value={progress} />;
};

export default CircularProgressBar;



// WEBPACK FOOTER //
// ./src/components/loading/CircularProgressBar.js